// extracted by mini-css-extract-plugin
module.exports = {"description":"Intro_description__3_KsO"};